import { cn } from '@/utils';

const Tile = ({
  id,
  index,
  parentId,
  children,
  className,
  isSelected,
  isDisabled,
  onClick,
  loadingIndex,
  LoadingIcon,
  dataAttributes,
  orgIndex
}) => (
  <div className={cn('flex flex-col my-3xs px-3xs', className)} {...dataAttributes}>
    <button
      data-testid={process.env.RENDER_TESTIDS ? id : undefined}
      className={cn(
        'flex flex-1 cursor-pointer px-4xs truncate justify-center relative items-center border border-neutral-medium w-rounded',
        'font-semibold text-center text-sm whitespace-normal',
        'hover:bg-neutral-lighter desktop:text-base',
        isDisabled ? 'opacity-40 bg-neutral-lighter cursor-not-allowed' : '',
        isSelected
          ? 'bg-neutral-lighter shadow ring-1 ring-inset ring-[color:var(--theme-link-border-color-4)] border-[color:var(--theme-link-border-color-4)]'
          : '',
      )}
      onClick={() => onClick({ parentId, id, is_selected: isSelected, index, orgIndex })}
    >
      <Choose>
        <When condition={LoadingIcon && loadingIndex === `${parentId}_${id}`}>
          <span className="flex absolute inset-y-0 items-center">
            <LoadingIcon />
          </span>
        </When>
        <Otherwise>{children}</Otherwise>
      </Choose>
    </button>
  </div>
);

export default Tile;
